// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.time-box[data-v-22618642],\n.selector-group[data-v-22618642] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.time-box[data-v-22618642] {\n  justify-content: space-between;\n  align-items: center;\n}\n.selector-group[data-v-22618642] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.time-selector[data-v-22618642]:first-child {\n  margin-right: 3rem;\n}\n.selector-label[data-v-22618642] {\n  margin: 0.5rem 1rem 0.5rem 0;\n}\n", ""]);
// Exports
module.exports = exports;
